import { Checkbox } from "@mui/material";
import {
    ReactElement,
    ButtonHTMLAttributes
} from "react";
import { Arrowleft } from "../../assets";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    stepTitle: string;
    stepDesc: string;
    onClick?: any;
    stepSubTitle?: string;
    hasBorder?:boolean;
}
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
export function StepperItemMobileUpdate({ stepTitle, stepDesc, onClick, stepSubTitle , hasBorder}: Props): ReactElement {
    return (
        <div className={`${hasBorder ? "stepper-update-border" : "" } stepper-item-mobile-update`}>
            <div className=" d-flex align-items-center justify-content-between w-100" onClick={onClick}>
                <div className="d-flex">
                    <Checkbox {...label} checked={true} sx={{

                        color: "#155a9e",
                        '&.Mui-checked': {
                            color: "#155a9e",
                        },
                        '&.MuiCheckbox-root': {
                            padding: 0
                        }

                    }} />

                    <div className="stepper-item-mobile-update-content">
                        <span className="step-title">
                            {stepTitle}
                        </span>
                        <span className="step-subtitle">
                            {stepSubTitle}

                        </span>
                        <span className="step-desc">
                            {stepDesc}

                        </span>

                    </div>
                </div>
                <Arrowleft color="#000000" className="stepper-item-mobile-update-arrow" />
            </div>
        </div>
    )
}

export default StepperItemMobileUpdate;